import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import { generateOauthState } from '@/utils/auth';
import TButton from '@/components/atoms/t-button.vue';

interface Props {
  redirectUri: string;
  redirectTo?: string | null;
  page?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FacebookButton',
  props: {
    redirectUri: null,
    redirectTo: { default: null },
    page: { default: '/' }
  },
  setup(__props: any) {

const props = __props as { redirectUri: string, redirectTo: string | null, page: string };

const { $config } = useContext();

/**
 * @property {String} redirectTo - The static url that facebook will redirect back to. This has to be configured in the facebook developer console.
 * @property {String} page - The current page. This is used to redirect back to the users context as we lose that after going through the oauth flow.
 */


const getFacebookCode = (): void => {
  const redirectTo = props.redirectTo ?? (props.page === '/signup/' ? '/hub/' : props.page);
  const url = new URL('oauth', 'https://www.facebook.com/v15.0/dialog/');

  url.searchParams.append('client_id', $config.facebookAppId);
  // This hash needs to be here at the end otherwise meta/fb appends an invalid one that breaks nuxt
  url.searchParams.append('redirect_uri', `${$config.baseURL}${props.redirectUri}#fb`);
  url.searchParams.append('response_type', 'code');
  url.searchParams.append('state', generateOauthState('facebook', redirectTo));
  url.searchParams.append('scope', 'email public_profile');

  window.location.href = url.toString();
};

return { __sfc: true,$config, props, getFacebookCode, TButton }
}

})